import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import ContactMaintenance from "./contactMaintenance";
import General from "./general";
import "./styles.scss";

enum PreferencePages {
    General = "General",
    ContactMaintenance = "Contact Maintenance",
}

function UserPreference() {
    const permissions = useSelector((state: RootState) => state.permissions);
    const [selectedPage, setSelectedPage] = useState<PreferencePages>(PreferencePages.General);

    const canMaintainContacts = permissions.Tenant.ContactMaintenance;

    // the page shown is the selected one, unless the user has lost access to it
    const page =
        selectedPage === PreferencePages.ContactMaintenance && !canMaintainContacts
            ? PreferencePages.General
            : selectedPage;

    const linkClass = (link: PreferencePages) => (page === link ? "selectedPreference" : "preference");

    return (
        <div className="alternateView">
            <div className="col1">
                <div className="header">Preferences</div>
                <div
                    className={linkClass(PreferencePages.General)}
                    onClick={() => setSelectedPage(PreferencePages.General)}
                >
                    General
                </div>
                {canMaintainContacts && (
                    <div
                        className={linkClass(PreferencePages.ContactMaintenance)}
                        onClick={() => setSelectedPage(PreferencePages.ContactMaintenance)}
                    >
                        Contact Maintenance
                    </div>
                )}
            </div>
            <div className="col2">
                {page === PreferencePages.General && <General></General>}
                {page === PreferencePages.ContactMaintenance && <ContactMaintenance></ContactMaintenance>}
            </div>
        </div>
    );
}
export default UserPreference;
